import { atom } from "recoil";


export const showQrCameraState = atom<boolean>({
    key: "showQrCameraState",
    default: false,
});
